<egi-card class="text-center">
  <egi-info
    *ngIf="info"
    style="position: absolute; top: 10px; right: 10px"
    [info]="info"
  ></egi-info>
  <h2>{{ title }}</h2>
  <div
    [ngClass]="{
      'font-xs': textSize === 'xs',
      'font-sm': textSize === 'sm',
      'font-md': textSize === 'md',
      'font-lg': textSize === 'lg',
      'font-xl': textSize === 'xl'
    }"
  >
    <div *ngIf="wEdifice > woEdifice" class="text-nowrap text-success">
      +{{ ((100 * (wEdifice - woEdifice)) / woEdifice).toFixed(1) }}%
    </div>
    <div *ngIf="wEdifice < woEdifice" class="text-nowrap text-primary">
      {{ ((100 * (wEdifice - woEdifice)) / woEdifice).toFixed(1) }}%
    </div>
  </div>
  <div class="row text-dark font-xs">
    <div class="col-6">Edifice Influence</div>
    <div class="col-6">No Edifice Influence</div>
  </div>
  <div class="row text-dark font-sm">
    <div class="col-6">
      <div *ngIf="dollar" class="inline">$</div>
      {{ percent ? wEdifice.toFixed(1) : wEdifice.toFixed(0) }}
      <div *ngIf="percent" class="inline">%</div>
    </div>
    <div class="col-6">
      <div *ngIf="dollar" class="inline">$</div>
      {{ percent ? woEdifice.toFixed(1) : woEdifice.toFixed(0) }}
      <div *ngIf="percent" class="inline">%</div>
    </div>
  </div>
</egi-card>
